<template>
  <div>
    <AppHeader />
    <div v-if="individual || personal" class="leaderboard">
      <v-tabs
        color="dark"
        dark
        grow
        slider-color="transparent"
      >

        <v-tab ripple>
          Teams
        </v-tab>
        <v-tab ripple>
          Individuals
        </v-tab>

        <v-tab-item>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <h1 class="app-title">
                  Leaderboard
                </h1>
              </v-flex>
              <v-flex xs12>
                <v-card
                  class="leaderboard_total-card white--text"
                >
                  <v-card-title>
                    <div>
                      <div class="headline font-weight-light">
                        NMG Miles
                      </div>
                      <div class="headline">{{getTeams.total_nmg}}</div>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
              <!-- <v-flex xs6>
                <v-card
                  class="leaderboard_total-card white--text"
                >
                  <v-card-title>
                    <div>
                      <div class="headline font-weight-light">
                        Total ZAR
                      </div>
                      <div class="headline">{{getTeams.total_zar}}</div>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex> -->
            </v-layout>
          </v-container>
          <v-container v-if="filtredLeaderboard">
            <v-layout row>
              <v-flex md12>
                <v-text-field
                  v-model="searchTeam"
                  color="teal lighten-2"
                  label="Search team"
                  clearable
                  prepend-inner-icon="fas fa-search fa-sm"
                />
                <LeaderBoardTable
                  v-if="filtredLeaderboard.length"
                  v-bind:table-items="filtredLeaderboard"
                  v-bind:divider="teamsLeaderboardProgressDivider"
                  v-bind:heading-items="teamsLeaderboardHeaders"
                />
                <div v-else>
                  No results
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-container>
            <v-layout
              row
              wrap
            >
              <v-flex xs12>
                <h1 class="app-title">Individual Results</h1>
              </v-flex>
              <v-flex xs12>
                <v-card
                  class="leaderboard_total-card white--text"
                >
                  <v-card-title>
                    <div>
                      <div class="headline font-weight-light">
                        NMG Miles
                      </div>
                      <div class="headline">{{getTeams.total_nmg}}</div>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex>
              <!-- <v-flex xs6>
                <v-card
                  class="leaderboard_total-card white--text"
                >
                  <v-card-title>
                    <div>
                      <div class="headline font-weight-light">
                        Total ZAR
                      </div>
                      <div class="headline">{{getTeams.total_zar}}</div>
                    </div>
                  </v-card-title>
                </v-card>
              </v-flex> -->
            </v-layout>
          </v-container>
          <v-container v-if="individualLeaderboard">
            <v-layout row>
              <v-flex xs12>
                <v-text-field
                  v-model="searchPersonal"
                  color="teal lighten-2"
                  label="Search"
                  clearable
                  prepend-inner-icon="fas fa-search fa-sm"
                />
                <LeaderBoardTable
                  v-if="individualLeaderboard.length"
                  v-bind:table-items="individualLeaderboard"
                  v-bind:divider="individualLeaderboardProgressDivider"
                  v-bind:heading-items="individualLeaderboardPersonalHeaders"
                />
                <div v-else>
                  No results
                </div>
              </v-flex>

            </v-layout>
          </v-container>
        </v-tab-item>

      </v-tabs>
      <BottomNavigation />
    </div>
     <div v-else class="text-xs-center">
  <v-progress-linear :indeterminate="true"></v-progress-linear>

    </div>
  </div>
</template>

<script>
  import AppHeader from '../components/AppHeader';
  import BottomNavigation from '../components/BottomNavigation';
  import LeaderBoardTable from '../components/leaderboard-table/LeaderBoardTable';
  //import { LEADERBOARD_REQUEST, PERSONAL_LEADERBOARD_REQUEST } from '../store/actions/leaderboard';
  import { mapGetters } from 'vuex';

  export default {
    name: "Leaderboard",
    components: {
      AppHeader,
      BottomNavigation,
      LeaderBoardTable,
    },
    data() {
      return {
        searchTeam: '',
        searchPersonal: '',
        individual: false,
        personal: false,
        teamsLeaderboardHeaders: [
          {
            text: 'Team',
          },
          {
            //text: 'Zar/Person',
            text: 'NMG miles/Person'
          },
        ],
        individualLeaderboardPersonalHeaders: [
          {
            text: 'User',
          },
          {
            text: 'NMG miles'
          }
        ],

      }
    },
    computed: {
      ...mapGetters(
        'leaderboard', ['getTeams', 'getIndividual'],
        ),
      filtredLeaderboard: function () {
        if(this.searchTeam) {
          return this.getTeams.teams.filter( team => team.name.toLowerCase().search(this.searchTeam.toLowerCase()) != -1  );
        }
        return this.getTeams.teams;
      },
      individualLeaderboard: function () {
        if(this.searchPersonal) {
          return this.getIndividual.filter( (persone) => {       
            let name = persone.first_name.toLowerCase() + ' ' + persone.last_name.toLowerCase();
            console.log(name)
            return name.search(this.searchPersonal.toLowerCase()) != -1;
          });
        }
        return this.getIndividual;
      },
      teamsLeaderboardProgressDivider: function () {
        let lb = this.getTeams.teams;
        let buffer = [];
        for ( let item of lb) {
          //buffer.push(parseFloat(item.zar.replace(/[.,]/g,'')));
          buffer.push(parseFloat(item.nmg_mile.replace(/[.,]/g,'')));
        }
        function getMaxOfArray(numArray) {
          return Math.max.apply(null, numArray);
        }
        let max = getMaxOfArray(buffer);
        let divider = max / 100;
        return divider;
      },
      individualLeaderboardProgressDivider: function () {
        let lb = this.getIndividual;
        let buffer = [];
        for ( let item of lb) {
          buffer.push(parseFloat(item.nmg_miles.replace(/[.,]/g,'')));
        }
        function getMaxOfArray(numArray) {
          return Math.max.apply(null, numArray);
        }
        let max = getMaxOfArray(buffer);
        let divider = max / 100;
        return divider;
      }
    },
    mounted() {
      this.$store.dispatch('leaderboard/requestIndividual').then(() => {
          this.individual = true;
          })
          .catch(err => {
            
            });
      this.$store.dispatch('leaderboard/requestTeams').then(() => {
          this.personal = true;
          })
          .catch(err => {
            
            });
    },
  }
</script>

<style scoped>
  .leaderboard {
    padding-bottom: 100px;
  }
  .leaderboard_total-card {
    background-image: linear-gradient(119deg, #fe8080 0%, #c41230 100%);
  }
  .leaderboard_total-card:nth-child(odd) {
    margin-right: 5px;
  }
  .leaderboard_total-card:nth-child(even) {
    margin-left: 5px;
  }
</style>
